<script>
    export let title = ''
    export let open = false

    /**
     * @type HTMLSpanElement
     */
    let modal
    /**
     * @type HTMLButtonElement
     */
    let closeButton
    /**
     * @type Element
     */
    let trigger

    /**
     * 
     * @param event {MouseEvent}
     */
    function handleClick(event) {
        const target = /** @type HTMLElement */(event.target);

        if (open) {
            if (closeButton.contains(target)) {
                open = false
            } else {
                // click outside
                if (modal.contains(target)) {
                    console.log('inside, ignore');
                }
                else {
                    open = false
                }
            }
        } else {
            if (trigger.contains(target)) {
                open = true
            }
        }
    }

    /**
     * @param event {KeyboardEvent}
     */
    function handleKeydown(event) {
        if (open && event.key === "Escape") {
            open = false
        }
    }

</script>

<svelte:window on:click={handleClick} on:keydown={handleKeydown} />

<span class="cursor-pointer" bind:this={trigger}>
    <slot name="trigger">
        <button />
    </slot>
</span>

{#if open}
    <div
        class="modal flex items-center justify-center fixed left-0 bottom-0 max-width w-full h-full bg-gray-400 bg-opacity-70"
    >
        <div bind:this={modal} class="bg-white rounded-lg m-4">
            <div class="flex flex-col items-start p-4 max-w-[80vw] max-h-[80vh]">
                <div class="flex items-center w-full">
                    <div class="text-gray-900 font-sans text-lg">{title}</div>
                    <button bind:this={closeButton} class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
                            <path
                                d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                            />
                        </svg>
                    </button>
                </div>
                <hr />
                <div class="overflow-auto">
                    <slot />
                </div>
            </div>
        </div>
    </div>
{/if}
